import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteDocumentCategory = (
    token: string,
    backend: string,
    id: string,
) => {
    return fetch(
        `${getApiUrl(backend)}delete_document_category/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteDocumentCategory